import { render, staticRenderFns } from "./Zyzbody.vue?vue&type=template&id=03519482&scoped=true&"
import script from "./Zyzbody.vue?vue&type=script&lang=js&"
export * from "./Zyzbody.vue?vue&type=script&lang=js&"
import style0 from "./Zyzbody.vue?vue&type=style&index=0&id=03519482&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03519482",
  null
  
)

export default component.exports